import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticStyle:{"background-color":"#f0f3f4"},attrs:{"id":"inspire"}},[_c('Side'),_c('Page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }